<template>
  <div class="drop-menu-view">

    <!-- 用户下拉菜单带图标 -->
    <el-dropdown ref="dropdown" v-if="menuInfo.type === 'user'" placement="bottom" @command="handleCommand">
      <span class="el-dropdown-link user-drop-menu">
        <img class="drop-img" src="../../assets/image/home/user_icon.png" alt="" />
        <p class="drop-name">{{userName}}</p>
        <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
         <img class="arrow-icon" src="../../assets/image/home/head_drow_icon.png" alt="">
      </span>

      <template slot="title">
        <span>{{$t('course')}}</span>
      </template>
      <el-dropdown-menu slot="dropdown" v-if="menuInfo.dropArr">
        <el-dropdown-item v-for="(item, index) in menuInfo.dropArr" :key="index" :command="item">{{item.name}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <!-- 纯文本下拉菜单 -->
    <el-dropdown ref="dropdown" v-if="menuInfo.type !== 'user'" placement="bottom" @command="handleCommand">
      <span class="el-dropdown-link">
        {{menuInfo.defaultValue}}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item disabled v-if="menuInfo.type === 'course'">
          <span class="seciton-drop">{{$t('course')}}</span>
        </el-dropdown-item>
        <el-dropdown-item :class="[item.select ?'base selected':'base']" v-for="(item, index) in menuInfo.dropArr" :key="index" :command="item">
          {{item.name}}
          <i v-if="item.select" class="el-icon-check menuicon"></i>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <abiltyBeginDialog :dialogVisible="beginShow" :dialogInfo="dialogInfo" @restart="exit" @coninute="coninute" />
  </div>
</template>

<script>
import { setup } from "@/locales";
import { setStore, getStore, clone, removeSession, getSession } from "@/utils/index";
import abiltyBeginDialog from "@/components/common/abiltyBeginDialog.vue";
import {userinfo} from "../../api/user";
import { onMounted } from "vue";

const getUserDisplayName = () => {
  const userInfoStr = getStore('userInfo');
  if (!userInfoStr || userInfoStr === 'null') {
    return '';
  }
  try {
    const userInfo = JSON.parse(userInfoStr);
    const displayName = userInfo && (userInfo.userName || userInfo.accountNumber);
    return displayName ? String(displayName).trim() : '';
  } catch (error) {
    return '';
  }
};

export default {
  inject: ['reload'],
  props: {
    menuInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    abiltyBeginDialog
  },
  data() {
    return {
      dialogInfo: {
        content: this.$t("exitContent"),
        leftText: this.$t("exit"),
        rightText: this.$t("coninute")
      },
      userName: getUserDisplayName(),
      // userName: getSession('name') ? getSession('name') : '',
      beginShow: false,
      isFinished: false,
      isExit: false,
      // isokfalge: true,
    }
  },
  mounted() {
    this.setUserName();
    if (this.$EventBus) {
      this.$EventBus.$on('userInfoUpdated', this.setUserName);
    }
  },
  beforeDestroy() {
    if (this.$EventBus) {
      this.$EventBus.$off('userInfoUpdated', this.setUserName);
    }
  },
  methods: {
    setUserName() {
      this.userName = getUserDisplayName();
    },
    handleCommand(item) {
      console.log("---- handleCommand ----", item);
      if (this.menuInfo.type == 'language') {
        let name = this.$router.history.current.name
        // 前测答题，后测试答题
        if (name == "checkAnswer" || name == 'abilityAnswer') {
          this.$abiltyDialog.showMsgBox({
            dialogInfo: this.dialogInfo
          }).then(async (val) => {
            //退出
            // this.isokfalge = false
            this.languageDrop(item)
          }).catch(() => {
            //继续
            // this.isokfalge= true
            // this.languageDrop(item)
          });
        } else {
          this.languageDrop(item)
        }
        return
      }
      this.$emit("dropCommand", item);
    },
    // zh_CN: Object.assign(zh, zhLocale),//中文简体
    // en_US: Object.assign(en, enLocale),//英文
    // zh_TW: Object.assign(tw, twLocale),//中文繁体
    // th_TH: Object.assign(th, thLocale)//泰文

    // 继续测试
    coninute() {
      this.beginShow = false;
    },
    // 退出
    exit() {
      this.isExit = true;
      if(getSession("projectId")){
        this.$router.push({
          path: "/projectCourseList",
          query:{
              id: getSession("projectId")
          }
        })
        return
      }
      this.$router.replace({ path: "/home" });
    },

    languageDrop(item) {
      console.log("item11==", item)
      console.log("this.$router==111==", this.$router)

      switch (item.action) {
        case "chinese":
          this.$i18n.locale = 'zh_CN';
          setup("zh_CN");
          break;
        case "english":
          this.$i18n.locale = 'en_US';
          setup("en_US");
          break;
        case "traditional":
          this.$i18n.locale = 'zh_TW';
          setup("zh_TW");
          break;
        case "thai":
          this.$i18n.locale = 'th_TH';
          setup("th_TH");
          break;
        default:
          break;
      }
      let name = this.$router.history.current.name
      if (name != 'home' && name != 'login' && name != '') {
        if (name == "checkAnswer" || name == 'abilityAnswer') {
          this.reload()
        } else {
          this.$router.replace({ path: "/home" });
          this.reload()
        }
      } else {
        this.reload()
      }

    },
  }
};
</script>

<style lang="scss" scoped>
.menuicon {
  position: absolute;
  right: 0;
  top: 10px !important;
  font-size: 16px;
}
.base {
  position: relative;
  line-height: 0.225rem !important;
}
.drop-menu-view {
  //margin-left: var(--margin-x-23);
  //margin-left: 0.4125rem;
  cursor: pointer;
}
.drop-img {
  display: inline-block;
  width: var(--width-20);
  height: var(--width-20);
  //width: 0.2125rem;
  //height: 0.2125rem;
}

.drop-name{
  display: inline-block;
  vertical-align: middle;
  //margin-top: -.17rem;
  // margin-top: -28px;/*no*/
  max-width: 120px;/*no*/
  //font-size: .1rem;
  // margin-left: var(--margin-x-5);
  font-size: 18px;/*no*/
  font-weight: var(--font-weight-l);
  color: #455765;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.arrow-icon {
  width: var(--width-14);
  height: var(--width-14);
}

.drop-name + .el-icon--right{
  display: inline-block;
  vertical-align: middle;
  font-size: var(--font-size-m);
  font-weight: var(--font-weight-m);
  color: var(--color-font-t1);
  // margin-top: -24px;/*no*/
  //margin-top: -.14rem;
  margin-left: 0;
}

.seciton-drop {
  color: #d1d2d5;
  font-size: 0.15rem;
  font-weight: 500;
}
.el-dropdown-menu {
  overflow: hidden;
  overflow-y: auto;
  max-height: 2.1425rem;
  top: 0.375rem !important;
  // overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  margin: 0.03125rem 0;

  &::-webkit-scrollbar {
    width: 8px;
    height: 5px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    height: 50px;
    background: #a8a8a8;
    display: none;
  }
  &::-webkit-scrollbar-track {
    // box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
    border-radius: 4px;
    background: transparent;
  }
}
.el-dropdown-menu__item {
  font-size: 0.1rem;
}
.el-dropdown-link {
  font-size: 0.1rem;
}
.user-drop-menu{
  display: flex;
  align-items: center;
  gap: var(--margin-x-4);
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled) {
  &:hover {
    border: none !important;
    background-color: #f8f8fc !important;
    color: #5867fe;
    font-weight: bold;
    font-size: 0.1rem;
  }
}
.selected {
  // background-color: red;
  // width: 278px;
  // height: 0.21875rem;
  // line-height: 0.21875rem;
  background: #f8f8fc;
  // box-shadow: 0px 0px 4px 0px #eaeaea;
  // color: #5867fe;
  // width: 149px;
  // height: 22px;
  font-size: 16px;
  // font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #5867fe;
  // line-height: 22px;
}
.el-dropdown-menu__item {
  padding: 0 0.35rem 0 0.25rem;
}
</style>
<style>

</style>



// WEBPACK FOOTER //
// src/components/home/dropMenu.vue